module.exports = __webpack_public_path__ + "static/media/tools-link.d8ede280.svg";